import { Component, Output, EventEmitter, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { UploadFileType } from 'app/models/dto/upload-file-type.model';
import { AdvancedFileUploadComponent, FileWithCategory } from './advanced-file-upload.component';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { DocumentCategory } from 'app/models/dto/document-category.model';
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatDividerModule } from '@angular/material/divider';

/**
 * FileUploadDialogComponent wraps the FileUploadComponent when you want to
 * use it within a modal.
 */
@Component({
  selector: 'advanced-file-upload-dialog',
  templateUrl: './advanced-file-upload-dialog.component.html',
  imports: [
    CommonModule,
    MatDialogModule,
    MatIconModule,
    AdvancedFileUploadComponent,
    FormsModule,
    MatIconModule,
    MatInputModule,
    MatButtonModule,
    MatFormFieldModule,
    MatSelectModule,
    MatDividerModule
  ]
})
export class AdvancedFileUploadDialogComponent {
/* eslint-disable @angular-eslint/no-output-on-prefix */
  @Output() onClose = new EventEmitter<void>();
  @Output() fileInput = new EventEmitter<File>();
  @Output() fileListInput = new EventEmitter<FileWithCategory[]>();

  fileList: FileWithCategory[];
  formIsValid = false;
  isUploading = false;
  dialogTitle = this.data.title;
  categories = this.data.categories;

  /**
   * Inject data from the client via `data`.
   */
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {
      // Dialog data.
      title?: string;
      closeLabel?: string;
      // Pass through to file upload component.
      allowedFileTypes?: UploadFileType[];
      fileSizeLimit?: number;
      fileCount?: number;
      label?: string;
      fileSelectText?: string;
      buttonText?: string;
      categories: DocumentCategory[];
    },
    public selfDialogRef: MatDialogRef<AdvancedFileUploadDialogComponent>,
  ) {
  }

  close($event: Event) {
    $event.stopPropagation();
    this.selfDialogRef.close();
  }

  uploadDocuments() {
    this.isUploading = true;
    this.dialogTitle = 'Uploading...';
    this.fileListInput.emit(this.fileList);
  }

  handleFormIsValid(value = true) {
    this.formIsValid = value;
  }
}
